export default __webpack_public_path__ + "static/media/Bermejo.e41c66aa.jpeg";